import Field from "./Field";
import Input from "./Input";

function Phone({
  errorFormatMessage,
  errorMessage,
  fieldName,
  label,
  onBlur,
  requiredPlaceholder,
}: {
  errorFormatMessage: string;
  errorMessage?: string;
  fieldName: string;
  label: string;
  onBlur?: () => void;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="tel"
          className="w-64"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          type="tel"
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: (value) =>
          !value || value.replace(/\D/g, "").length >= 8 || errorFormatMessage,
      }}
      label={label}
      onBlur={onBlur}
    />
  );
}

export default Phone;
